import mrReport from '../api/match-report.api'
import store from './index.js'
// root state object.
// each Vuex instance is just a single state tree.
const state = {
  mrList: [],
  latestMrList: [],
  detailedMR: null
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  refreshReports (state, allReports) {
    state.mrList = allReports
  },
  refreshLatestReports (state, reports) {
    state.latestMrList = reports
  },
  updateDetailedMR (state, MR) {
    state.detailedMR = MR
  },
  removeDetailedMR (state) {
    console.log(state)
    state.detailedMR = null
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  getMatchReportList (context) {
    mrReport.api.getAllMatchReport()
      .then(response => {
        context.commit('refreshReports', response.data)
      },
      error => {
        console.log('impossible to load match report list from api: ')
        console.log(error)
      })
  },
  getlatestMatchReportList (context) {
    mrReport.api.getLatestlMatchReport()
      .then(response => {
        context.commit('refreshLatestReports', response.data)
      },
      error => {
        console.log('impossible to load match report list from api: ')
        console.log(error)
      })
  },
  getMatchReportListForLeague (context, leagueName) {
    mrReport.api.getAllMatchReportForLeague(leagueName)
      .then(response => {
        context.commit('refreshReports', response.data)
      },
      error => {
        console.log('impossible to load match report list from api: ')
        console.log(error)
      })
  },
  getMatchReportForTeam (context, id) {
    mrReport.api.getMatchReportForTeam(id)
      .then(response => {
        context.commit('refreshReports', response.data)
      },
      error => {
        console.log('impossible to load match report list for team from api: ')
        console.log(error)
      })
  },
  getDetailedMatchReport (context, id) {
    /* if (state.detailedMR && state.detailedMR.id === parseInt(id)) {
      return
    } */
    mrReport.api.getMatchReport(id)
      .then(response => {
        context.commit('updateDetailedMR', response.data)
      },
      error => {
        console.log('impossible to load detailed match report : ' + id)
        console.log(error)
      })
  },
  getAllMatchReportForCoach (context, coachId) {
    mrReport.api.getAllMatchReportForCoach(coachId)
      .then(response => {
        context.commit('refreshReports', response.data)
      },
      error => {
        console.log('impossible to load match report for current user : ')
        console.log(error)
      })
  },
  getPublishedMatchReport (context, size) {
    mrReport.api.getPublishedMatchReport(size)
      .then(response => {
        context.commit('refreshReports', response.data)
      },
      error => {
        console.log('impossible to load published match report list for team from api: ')
        console.log(error)
      })
  },
  invalidatMatchReportList (context) {
    context.commit('refreshReports', [])
  },
  invalidateDetailedMatchReport (context) {
    console.log('context')
    console.log(context)
    context.commit('removeDetailedMR')
  }
}

// getters are functions
const getters = {
  matchReportList: state => {
    return state.mrList
  },
  latestMatchReportList: state => {
    return state.latestMrList
  },
  matchReportListForTeam: (state, getters) => (teamId) => {
    let filtered = state.mrList.filter(report => {
      return report.home_report.team.id === teamId || report.visitor_report.team.id === teamId
    })
    return filtered
  },
  filteredMatchReportList: state => {
    if (store.getters.activatedLeague && state.mrList) {
      let al = store.getters.activatedLeague
      let filtered = state.mrList.filter(mr => { return mr.league.id === al })
      return filtered
    }
    return state.mrList
  },
  matchListForleague: state => leagueId => {
    if (state.mrList) {
      return state.mrList.filter(mr => { return mr.league.id === leagueId })
    }
    return []
  },
  matchListForLeagueAndWeek: (state, getters) => (leagueId, weekId) => {
    if (state.mrList) {
      let filtered = getters.matchListForleague(leagueId)
      filtered = filtered.filter(mr => { return mr.week && mr.week.id === weekId })
      return filtered
    }
    return []
  },
  detailedMatchReport: state => {
    return state.detailedMR
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/match-report.js